import "bootstrap";
import $ from "jquery";
import { popper } from "@popperjs/core";
import "jquery-mask-plugin";

import "../sass/main.scss";

import { SwiperCarousel } from "./swiperCarousel";
import { visibleSwiper } from "./visibleSwiper";
import { masks } from "./masks";
import { AccordionFaq } from "./accordion";
import { fakePlaceholder } from "./fakePlaceholder";
import { handleFileUpload } from "./handleFileUpload";

document.addEventListener("DOMContentLoaded", function () {
  SwiperCarousel();
  visibleSwiper();
  AccordionFaq();
  masks();
  fakePlaceholder();
  handleFileUpload();

  const urlParams = new URLSearchParams(window.location.search);
  const search = urlParams.get("search");

  if (search) {
    window.location.hash = "#artigos";
  }

  // PRODUTOS SEARCH BAR
  const $hamburguer = $(".produtosSearch .hamburguerOptions");
  const $optionsSelect = $(".produtosSearch .optionsSelect");

  // Alternar visibilidade ao clicar no hamburguer
  $hamburguer.on("click", function (e) {
    e.stopPropagation(); // Evita o clique propagar para o document

    const isExpanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", !isExpanded);

    $optionsSelect.css({
      visibility: !isExpanded ? "visible" : "hidden",
      opacity: !isExpanded ? "1" : "0",
    });
  });

  // Esconder ao clicar fora
  $(document).on("click", function (e) {
    if (
      !$hamburguer.is(e.target) &&
      $hamburguer.has(e.target).length === 0 &&
      !$optionsSelect.is(e.target) &&
      $optionsSelect.has(e.target).length === 0
    ) {
      $hamburguer.attr("aria-expanded", "false");
      $optionsSelect.css({
        visibility: "hidden",
        opacity: "0",
      });
    }
  });

  // Lógica para botão de tamanho (apenas visual)
  document.querySelectorAll(".btn-tamanho").forEach((btn) => {
    btn.addEventListener("click", () => {
      document
        .querySelectorAll(".btn-tamanho")
        .forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
    });
  });

  const btnPostProduto = document.querySelector(".btn-ver-mais");
  const extras = document.querySelectorAll(".extra-content");

  if (btnPostProduto && extras.length > 0) {
    btnPostProduto.addEventListener("click", function () {
      extras.forEach((el) => (el.style.display = "block"));
      btnPostProduto.style.display = "none";
    });
  }

  // HEADER MOBILE
  jQuery(document).ready(function ($) {
    const $container = $(".header .container");
    const $toggler = $(".header .navbar-toggler");

    function updateCustomWidth() {
      const isExpanded = $toggler.attr("aria-expanded") === "true";
      $container.toggleClass("customWidth", !isExpanded);
    }

    updateCustomWidth();

    if (window.MutationObserver) {
      new MutationObserver(updateCustomWidth).observe($toggler[0], {
        attributes: true,
        attributeFilter: ["aria-expanded"],
      });
    }

    // Fallback: escutar clique no botão
    $toggler.on("click", function () {
      setTimeout(updateCustomWidth, 5);
    });
  });

  const path = window.location.pathname;
  if (path.includes('/segment/') || path.includes('/segmento/')) {
    const parts = path.split('/').filter(Boolean);
    const slug = parts[parts.length - 1];
    const campo = document.getElementById('segmento');
    if (campo) {
      campo.value = slug;
    }
  }

  // const menuItems = document.querySelectorAll(".menu-item-has-children > a");

  // menuItems.forEach((item) => {
  //   item.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     const parent = this.parentElement;
  //     parent.classList.toggle("open");
  //   });
  // });

  const limit = urlParams.get('limit');

  // Se estiver carregando mais produtos, rolar automaticamente
  if (limit) {
    const alvo = document.getElementById("secao-produtos");
    if (alvo) {
      // Timeout para garantir que tudo renderizou
      setTimeout(() => {
        alvo.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 300);
    }
  }

});
